import { render, staticRenderFns } from "./ContractorUnitLeave.vue?vue&type=template&id=90820b28&scoped=true"
import script from "./ContractorUnitLeave.vue?vue&type=script&lang=js"
export * from "./ContractorUnitLeave.vue?vue&type=script&lang=js"
import style0 from "./ContractorUnitLeave.vue?vue&type=style&index=0&id=90820b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90820b28",
  null
  
)

export default component.exports